/**
 * BannerCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {Banner} from '@/model/resource/Banner'

/* TODO: review generated class */
@HttpExclude()
export class BannerCollection extends PageCollection<Banner> {
  constructor() {
    super(Banner)
  }

  queryAsPage() {
    return this.listBanner()
  }

  async listBanner() {
    return await Request.get(`/admin/banner`, {params: this.params})
      .name('listBanner')
      .as(this)
      .getResponse()
  }

  async listCsvBanner() {
    return await Request.get(`/admin/banner/csv`, {params: this.params})
      .name('listCsvBanner')
      .as(this)
      .getResponse()
  }
}
